export default {
  namespaced: true,
  state: {
    list: [],
    addAppToBusiness: false,
    addAppToBusinessObj: {},

    addResources: false,
    addResourcesObj: {},

    showResources: false,
    showResourcesObj: {},

    add: false,
    edit: false,
    editObj: {},
    delete: false,
    deleteObj: {},
  },
  getters: {
    list: state => state.list,
    addAppToBusiness: state => state.addAppToBusiness,
    addAppToBusinessObj: state => state.addAppToBusinessObj,
    addResources: state => state.addResources,
    addResourcesObj: state => state.addResourcesObj,
    showResources: state => state.showResources,
    showResourcesObj: state => state.showResourcesObj,


    add: state => state.add,
    edit: state => state.edit,
    editObj: state => state.editObj,
    delete: state => state.delete,
    deleteObj: state => state.deleteObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addAppToBusinessMutate(state, data) {
      state.addAppToBusiness = data;
    },
    addAppToBusinessObjMutate(state, data) {
      state.addAppToBusinessObj = data;
    },

    addResourcesMutate(state, data) {
      state.addResources = data;
    },
    addResourcesObjMutate(state, data) {
      state.addResourcesObj = data;
    },

    showResourcesMutate(state, data) {
      state.showResources = data;
    },
    showResourcesObjMutate(state, data) {
      state.showResourcesObj = data;
    },

    addMutate(state, data) {
      state.add = data;
    },
    editMutate(state, data) {
      state.edit = data;
    },
    editObjMutate(state, data) {
      state.editObj = data;
    },
    deleteMutate(state, data) {
      state.delete = data;
    },
    deleteObjMutate(state, data) {
      state.deleteObj = data;
    },
  },
  actions: {

    setList(context, data) {
      context.commit('listMutate', data);
    },
    setAddAppToBusiness(context, data) {
      context.commit('addAppToBusinessMutate', data);
    },
    setAddAppToBusinessObj(context, data) {
      context.commit('addAppToBusinessObjMutate', data);
    },
    setAddResources(context, data) {
      context.commit('addResourcesMutate', data);
    },
    setAddResourcesObj(context, data) {
      context.commit('addResourcesObjMutate', data);
    },
    setShowResources(context, data) {
      context.commit('showResourcesMutate', data);
    },
    setShowResourcesObj(context, data) {
      context.commit('showResourcesObjMutate', data);
    },


    setAdd(context, data) {
      context.commit('addMutate', data);
    },
    setEdit(context, data) {
      context.commit('editMutate', data);
    },
    setEditObj(context, data) {
      context.commit('editObjMutate', data);
    },
    setDelete(context, data) {
      context.commit('deleteMutate', data);
    },
    setDeleteObj(context, data) {
      context.commit('deleteObjMutate', data);
    },
  },
};
